import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { Heading3 } from "styles/elements/Headings";
import { CssFlex } from "styles/helpers/layout";

export const StyledPageContainer = styled(CssFlex)<Props>`
  min-height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 3rem;
  background-color: ${(props: Props) => props.theme.palette.secondary._900};
`;

export const StyledContentContainer = styled(CssFlex)<Props>`
  padding: 3rem;
  width: 30rem;
  max-width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 2rem;
  border-radius: 1rem;
  box-shadow: 0px 8px 10px 1px #11111112;
  background-color: ${(props: Props) => props.theme.palette.neutral.white};
  text-align: center;
`;

export const StyledGroupName = styled(Heading3)<Props>`
  color: ${(props: Props) => props.theme.palette.secondary.brand};
`;
